/**
 * @generated SignedSource<<994231445f227a67e1aaccbbe4790b5b>>
 * @relayHash 0f84e07ae7daaa03ff834c7e22000d77
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 54df31e8c4d8a985ea8cf57de4e9987537d70dbc168cfc0cfa0a076f20f53d78

import type { ConcreteRequest } from 'relay-runtime';
export type IsSuperAdminQuery$variables = Record<PropertyKey, never>;
export type IsSuperAdminQuery$data = {
  readonly user: {
    readonly confluence: {
      readonly roles: {
        readonly isSuperAdmin: boolean;
      } | null;
    } | null;
    readonly id: string | null;
  } | null;
};
export type IsSuperAdminQuery = {
  response: IsSuperAdminQuery$data;
  variables: IsSuperAdminQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": "user",
    "args": [
      {
        "kind": "Literal",
        "name": "current",
        "value": true
      }
    ],
    "concreteType": "AtlassianUser",
    "kind": "LinkedField",
    "name": "confluence_atlassianUser",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "concreteType": "ConfluenceUser",
        "kind": "LinkedField",
        "name": "confluence",
        "plural": false,
        "selections": [
          {
            "concreteType": "GraphQLConfluenceUserRoles",
            "kind": "LinkedField",
            "name": "roles",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "isSuperAdmin"
              }
            ]
          }
        ]
      }
    ],
    "storageKey": "confluence_atlassianUser(current:true)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "IsSuperAdminQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "IsSuperAdminQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "0f84e07ae7daaa03ff834c7e22000d77",
    "id": "54df31e8c4d8a985ea8cf57de4e9987537d70dbc168cfc0cfa0a076f20f53d78",
    "metadata": {},
    "name": "IsSuperAdminQuery",
    "operationKind": "query",
    "text": "query IsSuperAdminQuery{user:confluence_atlassianUser(current:true){id,confluence{roles{isSuperAdmin}}}}"
  }
};
})();

(node as any).hash = "9aa53dcf116596c8f8285a3aa93878ce";

export default node;
